/**
 * Shrink an image in the browser before upload: a phone photo is 4000px and 5 MB, far more than a
 * screen needs. Draws it onto a canvas no larger than the given box and re-encodes as JPEG. Falls back
 * to the original file if the browser can't decode it (rare formats), so an upload never fails here.
 */
export async function downscaleImage(file: File, opts: { maxWidth: number; maxHeight: number; quality?: number }): Promise<Blob> {
  try {
    const bitmap = await createImageBitmap(file)
    const scale = Math.min(1, opts.maxWidth / bitmap.width, opts.maxHeight / bitmap.height)
    if (scale === 1 && file.type === 'image/jpeg') return file
    const canvas = document.createElement('canvas')
    canvas.width = Math.round(bitmap.width * scale)
    canvas.height = Math.round(bitmap.height * scale)
    canvas.getContext('2d')!.drawImage(bitmap, 0, 0, canvas.width, canvas.height)
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', opts.quality ?? 0.85))
    return blob ?? file
  } catch {
    return file
  }
}
